import { render, staticRenderFns } from "./EntityDetail.vue?vue&type=template&id=75087e5f&scoped=true&"
import script from "./EntityDetail.vue?vue&type=script&lang=js&"
export * from "./EntityDetail.vue?vue&type=script&lang=js&"
import style0 from "./EntityDetail.vue?vue&type=style&index=0&id=75087e5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75087e5f",
  null
  
)

component.options.__file = "EntityDetail.vue"
export default component.exports